import styled from 'styled-components';

const SectionHeaderActionsContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default SectionHeaderActionsContainer;
